import request from '../../http/request'

export const configSave = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/system/config/save`, params)
}

export const tagTypeSave = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/tag/type/save`, params, {
    hiddenError: true
  })
}

export const configQuery = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/system/config/query`, params)
}

export const getTagTypeList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/tag/type/search`, { params })
}

export const batchSave = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/system/config/batchSave`, params)
}

export const uploadSKUs = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/uploadSKUs`, params, {
    hiddenError: true
  })
}

export const getNFCSKUList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/search`, params)
}
export const getDictionnaryDropList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/dictionnary/current`, { params })
}

export const getNFCSKUHistoryList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/history`, { params })
}
export const getDictionnaryHistoryDropList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/dictionnary/special/history`, { params })
}

export const getTagReportLogList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v2/api/tag/report/lifecycle`, { params })
}

export const nfcReportList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/tag/report/list`, params)
}

export const getNFCUpdateTime = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/sku/recently_updated_date`, { params })
}

export const reportRetryBind = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-ant-service/tag/report/retryBinding`, params, {
    reSend: true
  })
}

export const reportTagDisability = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/dashboard/tag/disability`, params, {
    hiddenError: true
  })
}

export const reportTagUnbind = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v2/api/tag/unbindUidRelatedSkuInfo`, params, {
    hiddenError: true
  })
}

export const getSeasonList = params => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/store/config/seasons`, params)
}

export const getStoreConfigList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/store/config/page`, params)
}

export const exportStoreConfig = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/store/config/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const downloadStoreLatest = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/store/config/latest/download`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const importStoreConfig = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant/store/config/manageStore/import`, params, {
    hiddenError: true
  })
}

export const getANTTemplateList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant-link/config/page`, params)
}

export const modifyANTTemplate = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant-link/config/modify`, params, {
    hiddenError: true
  })
}

export const deleteANTTemplate = params => {
  return request.delete(`${process.env.REACT_APP_API_URL}/nfc/v1/api/ant-link/config`, { params })
}

export const getRFDeviceList = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/rf/device/page`, params)
}

export const addRFDevice = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/rf/device/add`, params, {
    hiddenError: true
  })
}

export const addRFUpdate = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/rf/device/update`, params, {
    hiddenError: true
  })
}

export const changeRFDeviceStatus = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/rf/device/changeStatus`, params)
}
export const findFunctionModules = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/nfc/rf/device/findFunctionModules`)
}

export const suspiciousUidReportQuery = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/suspiciousUid/report/list`, params)
}

export const suspiciousUidReportDownload = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc/v1/api/suspiciousUid/report/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
